/* <soh-product-gallery>: scroll-snap slider. Arrows [data-gallery-prev/next], thumbnails [data-thumb],
   touch swipe (native scroll), mouse click-and-drag, keyboard arrows. Expand opens <soh-modal id="GalleryModal">. */
class SohProductGallery extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    if (!this.track) return;
    this.slides = [...this.track.children];
    this.thumbs = [...this.querySelectorAll('[data-thumb]')];
    this.i = 0;
    this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.go(i)));
    this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.go(this.i - 1));
    this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.go(this.i + 1));
    this.track.addEventListener('scroll', () => { cancelAnimationFrame(this.raf); this.raf = requestAnimationFrame(() => this.mark(Math.round(this.track.scrollLeft / this.track.clientWidth))); }, { passive: true });
    this.track.setAttribute('tabindex', '0');
    this.track.addEventListener('keydown', (e) => { if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.i - 1); } if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.i + 1); } });
    this.track.addEventListener('dragstart', (e) => e.preventDefault());
    this.initDrag();
    this.querySelector('[data-gallery-expand]')?.addEventListener('click', () => {
      const m = document.getElementById('GalleryModal'); const s = this.slides[this.i];
      if (m && s) { const img = m.querySelector('img'); if (img) { img.removeAttribute('srcset'); img.src = s.currentSrc || s.src; img.alt = s.alt; } m.open && m.open(); }
    });
    this.mark(0);
  }
  go(i) {
    const n = this.slides.length; if (!n) return;
    i = (i + n) % n;
    this.track.scrollTo({ left: i * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    this.mark(i);
  }
  mark(i) {
    i = Math.max(0, Math.min(i, this.slides.length - 1)); this.i = i;
    this.thumbs.forEach((t, j) => t.setAttribute('aria-current', String(i === j)));
    const active = this.thumbs[i]; if (active && active.parentElement) { const p = active.parentElement; const l = active.offsetLeft - p.clientWidth / 2 + active.clientWidth / 2; p.scrollTo({ left: l, behavior: 'smooth' }); }
    const c = this.querySelector('[data-gallery-count]'); if (c) c.textContent = (i + 1) + '/' + this.slides.length;
  }
  /* click-and-drag with a mouse; touch uses native scrolling */
  initDrag() {
    const t = this.track; let down = false, startX = 0, startLeft = 0, moved = false;
    t.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = t.scrollLeft;
      t.style.scrollSnapType = 'none'; t.style.scrollBehavior = 'auto'; t.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', (e) => {
      if (!down) return; const dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      t.scrollLeft = startLeft - dx;
    });
    const end = (e) => {
      if (!down) return; down = false; t.classList.remove('is-dragging');
      const dx = e.clientX - startX, w = t.clientWidth;
      let target = Math.round(startLeft / w);
      if (dx < -w * 0.12) target += 1; else if (dx > w * 0.12) target -= 1;
      target = Math.max(0, Math.min(target, this.slides.length - 1));
      t.scrollTo({ left: target * w, behavior: 'smooth' });
      setTimeout(() => { t.style.scrollSnapType = ''; t.style.scrollBehavior = ''; }, 400);
      this.mark(target);
    };
    window.addEventListener('pointerup', end); window.addEventListener('pointercancel', end);
    t.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  }
}
customElements.define('soh-product-gallery', SohProductGallery);
